import React, { useEffect, useState } from "react";
import MetaDataCard from "./manageStudents/MetaDataCard";
import TableMain from "./manageStudents/TableMain";
import WebUtils from "../../../../../utils/WebUtils";
import Utils from "../../../../../utils/Utils";
import { getGuideDetailsApi } from "../../../../../api/org-admin";

const ManageStudents = ({ setLoading, jobGuideIdentifier }) => {
  const userDetail = Utils.getUserDetail();
  const [jobDetails, setJobDetails] = useState(null);

  const getGuideDetails = () => {
    const url = `${getGuideDetailsApi}?organizationId=${
      userDetail?.organizationId || null
    }&jobGuideIdentifier=${jobGuideIdentifier}`;
    setLoading(true);

    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setJobDetails(result?.data?.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };
  useEffect(() => {
    getGuideDetails();
  }, []);
  return (
    <div>
      <MetaDataCard
        jobDetails={jobDetails}
        jobGuideIdentifier={jobGuideIdentifier}
        setLoading={setLoading}
      />
      <TableMain
        userDetail={userDetail}
        jobGuideIdentifier={jobGuideIdentifier}
        setLoading={setLoading}
        getGuideDetails={getGuideDetails}
      />
    </div>
  );
};

export default ManageStudents;
